import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { isPerguntaOutroFilled } from '../../utils-consultaSeguimento'
import { ConsultaSeguimentoPergunta20Model } from './model-consultaSeguimentoPergunta20'

export const convertConsultaSeguimentoPergunta20ToInput = (
  value: ConsultaSeguimentoPergunta20Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_20_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_20_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_20_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_20_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_20_EXEMPLOS?.RI_OU_GARGALHA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_20_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_20_EXEMPLOS?.FALA_OU_EMITE_SOM),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_20_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_20_EXEMPLOS?.PEDE_MAIS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_20_06,
      stResposta: isPerguntaOutroFilled(value.PERGUNTA_20_OUTRO) ? true : null,
      outros: value.PERGUNTA_20_OUTRO?.textValue,
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
